import $ from 'jquery';

if(document.querySelector("form#anmeldung")) {
    $("form#anmeldung .custom-select").change(function(e) {
        if(e.target.value) {
            e.target.classList.add('has-val');
        } else {
            e.target.classList.remove('has-val');
        }
    });
}

